<!--
	作者：masonchen
	时间：2017-04-10
	描述：车辆追踪地图组件
-->
<template>
	<div style="width: 100%;height: 100%;" v-loading="loadFMap" element-loading-text="加载中">
		<baidu-map style="height: 100%;"
			:center="center" 
			:zoom="16"
			:scroll-wheel-zoom="true" 
			@ready="ready">
		</baidu-map>
		<!--{lng: 120.39, lat: 36.073}-->
		<div v-show="showNumber == 'a'" style="position: absolute; z-index: 0; left: 30px;bottom:30px">
			<a type="button" class="btn-default btn active">1</a>
		</div>
		<div v-show="showNumber == 'b'" style="position: absolute; z-index: 0; right: 30px;bottom:30px">
			<a type="button" class="btn-default btn active">2</a>
		</div>
		<div v-show="showNumber == 'c'" style="position: absolute; z-index: 0; left: 30px;bottom:30px">
			<a type="button" class="btn-default btn active ">3</a>
		</div>
		<div v-show="showNumber == 'd'" style="position: absolute; z-index: 0; right: 30px;bottom:30px">
			<a type="button" class="btn-default btn active ">4</a>
		</div>
		
		<!--<div style="position: absolute; z-index: 255; right: 80px;top:30px">
			<button v-show="vehicleInfo.valid" type="button" class=" btn-primary btn car_chase_ico01" @click="refreshPosition" title="车辆轨迹"></button>
		</div>-->
		<div style="position: absolute; z-index: 255; right: 80px;top:30px">
			<button v-show="vehicleInfo.valid" type="button" class=" btn-primary btn car_chase_ico01" @click="showTrack" data-toggle="tooltip" data-placement="bottom" title="车辆轨迹"></button>
		</div>
		<div style="position: absolute; z-index: 255; right: 30px;top:30px">
			<button v-show="vehicleInfo.valid" class="btn-primary btn car_chase_ico02" @click="moveToQueue" data-toggle="tooltip" data-placement="bottom" title="移出地图"></button>
		</div>
		<div v-show="vehicleInfo.valid" style="position: absolute; z-index: 255; left:30px;top:30px">
			<dl class="car_chase_text">
			<dt>{{vehicleInfo.vehicleId}}</dt>
			<dd>
				<span>{{vehicleInfo.plateNumber}}</span>
				<span>{{vehicleInfo.ownerName}}</span>
				<span>时速：{{vehicleInfo.speed}}km</span>
				<span>定位：{{vehicleInfo.locMode}}</span>
				<span v-show="!vehicleInfo.locSuccess"><font color="red">暂无定位信息</font></span>
			</dd>
			</dl>
		</div>
	</div>
</template>
	
<script>
	import {mapMixin} from 'util/util.js'
	import {VEHICLE_TRACK} from 'static/constant.js'
	import { OPERATE_EXCEPTION, OPERATE_SUCCESS, SAVE_ENSURE } from 'static/message'
	export default{
		name: 'FollowMap',
		mixins:[mapMixin],
		data(){
			return {
				carIconName:'',
				carIcon:{},
				carMarker:{},
				map:null,
				BMap:'',		
			    center:{lng: 120.39, lat: 36.073},
			    lng: 120.39,    //方便用
			    lat: 36.073,
			    trackShow:false,
			    vehicleInfoT:{
					vehicleId:100029614,
					deviceId:105541,
					ownerName:'曹',
					plateNumber:'鲁B8888',
					id:8,
					lng: 120.39,
					lat: 36.073		
				},
				timer:{},
				deviceId:'',	//车辆deviceId
				temPoint:[],
				polyLine:{},
				loadFMap:false,
				url:'/monitor/locating/locatings/vehicle' //'/monitor/track/tracks/gps/'
			}
		},
		props:["showNumber","vehicleInfo","id"],
		watch:{
			'vehicleInfo.lat'(){
				this.addCarMarker();
			},
			'vehicleInfo.lng'(){
				this.addCarMarker();
			},
			'vehicleInfo.locSuccess'(){
				if(this.vehicleInfo.locSuccess)
				this.addCarMarker();
			},
			'vehicleInfo.valid'(val){
			//	console.log(val)
				const {map,BMap} = this;
				if(map==null)return;
				if(this.vehicleInfo.valid==false){
					this.map.removeOverlay(this.carMarker);//移除定位点
					clearInterval(this.timer)//关闭定时器
					this.getBrowserPos(map,BMap)//浏览器定位
				}else{
					this.refreshPosition();
					const that = this;
					this.timer = setInterval(function(){
						that.refreshPosition();
					},5000)
					
				}
			}
		},
		destroyed(){
			clearInterval(this.timer)//关闭定时器
			$('[data-toggle="tooltip"]').tooltip('hide')
		},
		mounted(){
			$(function () {//启用tooltip
				$('[data-toggle="tooltip"]').tooltip()
			})
		},
		methods: {
			ready(obj){				
				const {BMap,map} = obj;
				const {hideLogo} = this;
				map.addEventListener("tilesloaded",e=>hideLogo())
				this.map = map;
				this.BMap = BMap;	
				this.addCarMarker();
				if(this.vehicleInfo.vehicleId!=''){
					this.refreshPosition();
				}
			},
			hideLogo() {
				$('div.anchorBL').css('display', 'none');
			},
			showTrack(){//画轨迹路线
				this.loadFMap = true
				const {map,BMap} = this
				clearInterval(this.timer)
				map.clearOverlays()
				this.addCarMarker()
				if(this.deviceId == '') return
				this.$http.get(process.env.API_ROOT + '/trace/traces/gps/device/' + this.deviceId)
					.then(res=>{
						this.loadFMap = false
						let val = res.body.data;
						if(val.length <= 1){
							this.$parent.openModal1('该车辆没有轨迹')
						}else{
							/*map.removeOverlay(this.polyline)
							map.removeOverlay(this.carMarker)*/
							//加起点和终点
							let sPoint = new BMap.Point(Number(val[0].lngBd),Number(val[0].latBd))
							map.panTo(sPoint)
							let picUrlS = VEHICLE_TRACK.tip_icon_21
							this.addSEPoint(picUrlS,sPoint,map,BMap,'起')
							let ePoint = new BMap.Point(Number(val[val.length - 1].lngBd),Number(val[val.length-1].latBd))
							let picUrlE = VEHICLE_TRACK.tip_icon_24
							this.addSEPoint(picUrlE,ePoint,map,BMap,'终')
							//画轨迹
							for(let i = 0,length = val.length; i < length; i ++){
								if(val[i].lngBd !== null && val[i].latBd !== null){
									const points1 = new BMap.Point(val[i].lngBd,val[i].latBd)
									this.temPoint.push(points1);
									if(i == val.length - 1){//最后一个gps坐标点
										if(this.temPoint.length > 1){
											const that = this;
											this.setPolylineColor(val[i].speed,that.temPoint);
											this.temPoint.splice(0,that.temPoint.length);
										}
										break;
									}
									if(val[i + 1].lngBd !== null && val[i + 1].latBd !== null){
										this.drawPolyline(val[i],val[i+1]);
									}
								}
							}
							this.polyLine = new BMap.Polyline(this.temPoint)
							map.addOverlay(this.polyLine)
							
						}
					},res=>{
						this.loadFMap = false
						this.$parent.openModal1(res.data.message)
					})
					.catch(res=>{
						this.loadFMap = false
						this.$parent.openModal1(OPERATE_EXCEPTION)
					})
			},
			refreshPosition() {	//调车辆定位接口	
				let rtn = {};
				rtn.point={};
				let self = this;
				this.$http.get(process.env.API_ROOT + this.url+'?vehicleId='+this.vehicleInfo.vehicleId)
				.then( res => {
					if(res.data.success){
						//通知父组件
						if(res.data.data.length==0){
							// 无定位信息
							this.map.removeOverlay(this.carMarker);
							rtn.id = self.id;
							rtn.locSuccess = false;
							this.$emit('refreshPosition',rtn);					
							return ;
						}	
						rtn.locSuccess = true;
						rtn.point.lat=res.data.data[0].latBd;
						rtn.point.lng=res.data.data[0].lngBd;
						rtn.speed = res.data.data[0].speed;
						rtn.id = self.id;
						this.deviceId = res.data.data[0].deviceId
						this.$emit('refreshPosition',rtn);
						return ;
					}
					rtn.id = self.id;
					rtn.locSuccess = false;
					this.$emit('refreshPosition',rtn);					
					return ;	
					//移除失败 
				}, res => {
					
				}).catch(res=>{
					rtn.id = self.id;
					rtn.locSuccess = false;
					this.$emit('refreshPosition',rtn);					
					return ;
				})	
			},
			//添加车辆标记 位置
			addCarMarker(){
				if(this.vehicleInfo.lat == undefined || this.vehicleInfo.lat=='')return ;
				if(this.vehicleInfo.lng == undefined || this.vehicleInfo.lng=='')return;
				this.map.removeOverlay(this.carMarker);
				if(!this.vehicleInfo.valid) return;
				let point = new this.BMap.Point(this.vehicleInfo.lng,this.vehicleInfo.lat);
				let carMarker = new this.BMap.Marker(point);
				this.map.setCenter(point);
				this.map.addOverlay(carMarker);
				this.carMarker = carMarker;
			},
			//把此车移到队列
			moveToQueue(){//调修改队列接口
				this.$http.put(process.env.API_ROOT + '/monitor/track/tracks/left/'+this.vehicleInfo.id+'/0')
				.then( res => {
					if(res.data.success){
						//通知父组件
						this.$emit('moveToQueue',this);
					//	console.log('移动到队列成功');
						this.map.clearOverlays();
						return ;
					}
					//移除失败 
				},res => {
					this.$parent.openModal1('移动到队列失败！失败原因：'+ res.data.message)
				}).catch(res=>{
					this.$parent.openModal1(OPERATE_EXCEPTION)
				})
			},
			drawPolyline:function(obj1,obj2){//根据速度画出轨迹线（用颜色区分不同速度下的轨迹线）
				const {BMap} = this
				const that = this;
				if(obj1.speed <= 60){//当速度小于60
					const oSpeed1 = parseInt(obj1.speed/20);
					const oSpeed2 = parseInt(obj2.speed/20);
					if(oSpeed1 != oSpeed2){//分别是20或40或60
						this.temPoint.push(new BMap.Point(obj2.lngBd,obj2.latBd));
						this.setPolylineColor(obj1.speed,that.temPoint);
						this.temPoint.splice(0,this.temPoint.length)										
					}
				}else if(obj1.speed <= 120){				
					if(obj2.speed <= 60 || obj2.speed > 120){									
							this.temPoint.push(new BMap.Point(obj2.lngBd,obj2.latBd));		
							this.setPolylineColor(obj1.speed,that.temPoint);
							this.temPoint.splice(0,this.temPoint.length);	
						}
									
				}else{
						if(obj2.speed <= 120){	
						//	console.log(obj2.lngBd)
							this.temPoint.push(new BMap.Point(obj2.lngBd,obj2.latBd));
							this.setPolylineColor(obj1.speed,that.temPoint);
							this.temPoint.splice(0,this.temPoint.length);
						}
				}
			},
			setPolylineColor:function(startSpeed,points){//设置轨迹线颜色
				const {map,BMap} = this;
				var _color20 = {strokeColor:"#DF0101", strokeWeight:6, strokeOpacity:0.8};
			    var _color40 ={strokeColor:"#FFBF00", strokeWeight:6, strokeOpacity:0.8};
			    var _color60 = {strokeColor:"#A5DF00", strokeWeight:6, strokeOpacity:0.8};
			    var _color120 = {strokeColor:"#31B404", strokeWeight:6, strokeOpacity:0.8};
			    var _color120max = {strokeColor:"#0040FF", strokeWeight:6, strokeOpacity:0.8};
			    var polyline;
		    	if(parseFloat(startSpeed) <= 20){
		    		polyline= new BMap.Polyline(points, _color20);
		    	}else if(parseFloat(startSpeed) <= 40){
		    		polyline= new BMap.Polyline(points, _color40);
		    	}else if(parseFloat(startSpeed) <= 60){
		    		polyline= new BMap.Polyline(points, _color60);
		    	}else if(parseFloat(startSpeed) <= 120){
		    		polyline= new BMap.Polyline(points, _color120);
		    	}else {
		    		polyline= new BMap.Polyline(points, _color120max);
		    	}
				map.addOverlay(polyline);
			}
	
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// FollowMap.vue?8f156732